import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SimpleDateFormatPipe } from "./simple-date-format.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";
import { NoBillingPipe } from "./show-payment.pipe";
import { FullNamePipe } from "./fullname.pipe";

@NgModule({
  imports: [CommonModule],
  exports: [SimpleDateFormatPipe, TruncatePipe, NoBillingPipe, FullNamePipe],
  declarations: [SimpleDateFormatPipe, TruncatePipe, SafeHtmlPipe, NoBillingPipe, FullNamePipe]
})
export class SharedPipesModule {}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/shared-pipes.module.ts